import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../Services/AuthContext";
import {Link, useOutletContext} from "react-router-dom";
import {DetailsList, IconButton, PrimaryButton, SelectionMode, TooltipHost} from "@fluentui/react";
import {formatComments, filterTasks, sortColumns, taskWarning, modifyTask} from "../../Utilities/taskFunctions"
import AddTaskContractor from "../../Panel/Task/AddTaskContractor";
import AddTaskComment from "../../Panel/Task/AddTaskComment";
import DeleteTask from "../../Panel/Task/DeleteTask";
import {CSVDownloader} from "react-papaparse";

function TaskOpen() {
    const [user] = useContext(AuthContext);
    const [tasks, setTasks] = useState([]);
    const [sort, setSort] = useState({key: 'created'})
    const {userFilter, searchbox, refresh, setRefresh} = useOutletContext();
    const [filteredTasks, setFilteredTasks] = useState([])
    const [addComment, setAddComment] = useState(false);
    const [addRejectComment, setAddRejectComment] = useState(false);
    const [inProgressContractor, setInProgressContractor] = useState(false);
    const [doneContractor, setDoneContractor] = useState(false);
    const [deleteTask, setDeleteTask] = useState(false);

    const _sort = (e, col) => setSort(col);

    const taskActions = (item) => {
        return (<span>
            <IconButton iconProps={{iconName: 'ProgressRingDots'}} onClick={() => setInProgressContractor(item.id)}  />
            <IconButton iconProps={{iconName: 'CheckMark'}} onClick={() => setDoneContractor(item.id)} />
            <IconButton iconProps={{iconName: 'Blocked'}} onClick={() => setAddRejectComment(item.id)} />
            <IconButton iconProps={{iconName: 'Delete'}} onClick={() => setDeleteTask(item.id)} />
        </span>)
    }

    const taskAssignment = (item) => {
        if (item.assigned_to === null) {
            return (
                <span>
                    <IconButton iconProps={{iconName: 'FollowUser', title: "Przypisz mnie"}} onClick={() => modifyTask(item.id, 'assign', [], user, setRefresh, 'PUT')}  />
                </span>
            )
        } else {
            return (
                <span>
                    <IconButton iconProps={{iconName: 'UserRemove', title: "Usuń przypisanie"}} onClick={() => modifyTask(item.id, 'unassign', [], user, setRefresh, 'PUT')}  />
                    <span title={item.assigned_to_name}>{item.assigned_to_name}</span>
                </span>
            )
        }
    }

    useEffect(() => {
        const abortController = new AbortController();
        setTasks([]);
        async function fetchData() {
            await fetch(`/api/task/open`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setTasks(data.tasks);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [refresh]);


    useEffect(() => {
        sortColumns(columns, sort, setColumns, tasks, setTasks);
    }, [sort]);


    useEffect(() => {
        filterTasks(tasks, userFilter, user, searchbox, setFilteredTasks);
    }, [userFilter, tasks, searchbox]);


    const [columns, setColumns] = useState([
        {
            key: 'description',
            name: 'Opis',
            ariaLabel: 'Opis',
            fieldName: 'description',
            minWidth: 200,
            isResizable: true,
            isRowHeader: true,
            onColumnClick: _sort
        },

        {
            key: 'assigned_to',
            name: 'Przypisane do',
            ariaLabel: 'Przypisane do',
            fieldName: 'assigned_to',
            minWidth: 180,
            isResizable: true,
            onRender: taskAssignment,
        },
        {
            key: 'type',
            name: 'Typ',
            ariaLabel: 'Typ',
            fieldName: 'type',
            minWidth: 90,
            maxWidth: 150,
            isResizable: true,
            hide: true
        },
        {
            key: 'contractor',
            name: 'Wykonawca',
            ariaLabel: 'Wykonawca',
            fieldName: 'contractor',
            minWidth: 120,
            isResizable: true,
            onColumnClick: _sort,
        },
        {
            key: 'venture',
            name: 'Kontrakt',
            ariaLabel: 'Kontrakt',
            fieldName: 'venture',
            minWidth: 120,
            isResizable: true,
            onColumnClick: _sort,
        },
        {
            key: 'project',
            name: 'Projekt',
            ariaLabel: 'Projekt',
            fieldName: 'project',
            minWidth: 150,
            isResizable: true,
            isCollapsible: true,
            onColumnClick: _sort,
            onRender: (item) => (
                item.project_id !== null && (
                    <Link to={`/project/${item.project_id}`}>
                        <PrimaryButton text={item.project} />
                    </Link>
                )
            )
        },
        {
            key: 'comment',
            name: 'Komentarze',
            ariaLabel: 'Komentarze',
            fieldName: 'comment',
            minWidth: 45,
            isResizable: false,
            onRender: (item) => (<TooltipHost tooltipProps={formatComments(item)}>
                <IconButton onClick={() => setAddComment(item.id)} iconProps={{iconName: 'Comment'}}/></TooltipHost>)
        },
        {
            key: 'created',
            name: 'Utworzono',
            ariaLabel: 'Utworzono',
            fieldName: 'created',
            minWidth: 130,
            isResizable: false,
            isSorted: true,
            onRender: taskWarning,
            onColumnClick: _sort,
        },
        {
            key: 'edit',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'edit',
            minWidth: 130,
            maxWidth: 130,
            isResizable: true,
            onRender: taskActions
        }
    ]);
    return (
        <div>
            <DetailsList items={filteredTasks} columns={columns} selectionMode={SelectionMode.none} constrainMode={0}/>
            <CSVDownloader data={tasks} filename={`zadania`} bom={true} config={{delimiter: ';'}}><IconButton iconProps={ {iconName: 'ExcelDocument' }} title='Export CSV'/></CSVDownloader>
            <AddTaskContractor
                title={'W realizacji'}
                onSuccess={(payload) => modifyTask(inProgressContractor, 'progress', payload, user, setRefresh)}
                add={inProgressContractor}
                dismissPanel={() => setInProgressContractor(false)}
                type={'progress'}
            />
            <AddTaskContractor
                title={'Wykonane'}
                onSuccess={(payload) => modifyTask(doneContractor, 'complete', payload, user, setRefresh)}
                add={doneContractor}
                dismissPanel={() => setDoneContractor(false)}
                type={'complete'}
            />
            <AddTaskComment onSuccess={() => setRefresh(refresh + 1)} add={addComment} dismissPanel={() => setAddComment(false)}/>
            <AddTaskComment
                onSuccess= {() => modifyTask(addRejectComment, 'reject', [], user, setRefresh)}
                title={'Odrzuć Zadanie'} add={addRejectComment} dismissPanel={() => setAddRejectComment(false)}/>
            <DeleteTask onSuccess={() => setRefresh(refresh + 1)} open={deleteTask} dismiss={() => setDeleteTask(false)}/>
        </div>
    );
}

export default TaskOpen